// Framework presets — starting templates. Full question lists come from
// defaultFrameworkSections.json when section ids match; otherwise placeholders.

import { frameworkFromPreset } from "./frameworkUtils";

const section = (id, name, threshold, weight, required, items_count) => ({
  id,
  name,
  threshold,
  weight,
  required,
  items_count,
});

export const STANDARD_PRESET = {
  name: "ValidAIte TEVV Intake",
  version: 2,
  mandatory_defaults_version: 3,
  passing_mode: "weighted",
  default_threshold: 85,
  sections: [
    section("identity", "Identity & Ownership", 80, 1.0, true, 6),
    section("purpose", "Purpose & Function", 85, 1.0, true, 7),
    section("users", "User Structure", 90, 1.5, true, 8),
    section("architecture", "System Architecture", 85, 1.2, true, 10),
    section("data", "Data", 85, 1.2, true, 10),
    section("decision", "Decision & Autonomy", 90, 1.3, true, 8),
    section("consequence", "Consequence & Impact", 90, 1.5, true, 8),
    section("regulatory", "Regulatory & Compliance", 85, 1.0, true, 5),
    section("operational", "Operational", 80, 0.8, true, 8),
    section("controls", "Controls & Assurance", 85, 1.0, true, 10),
    section("success", "Success & Performance", 80, 0.9, true, 7),
    section("governance", "Governance", 80, 0.8, true, 5),
  ],
};

export const LITE_PRESET = {
  name: "ValidAIte Lightweight",
  version: 1,
  passing_mode: "weighted",
  default_threshold: 80,
  sections: [
    section("identity", "Identity & Ownership", 80, 1.0, true, 4),
    section("purpose", "Purpose & Function", 80, 1.0, true, 5),
    section("users", "User Structure", 85, 1.2, true, 6),
    section("architecture", "System Architecture", 80, 1.0, true, 6),
    section("consequence", "Consequence & Impact", 85, 1.3, true, 5),
    section("controls", "Controls & Assurance", 80, 1.0, true, 6),
  ],
};

export const DOMAIN_HEALTHCARE_PRESET = {
  name: "ValidAIte Healthcare Intake",
  version: 1,
  passing_mode: "weighted",
  default_threshold: 90,
  sections: [
    section("identity", "Identity & Ownership", 80, 1.0, true, 5),
    section("purpose", "Clinical Purpose", 90, 1.2, true, 8),
    section("users", "Patient & Clinician Roles", 90, 1.5, true, 8),
    section("data", "PHI & Clinical Data", 95, 1.5, true, 10),
    section("decision", "Clinical Decision Support", 95, 1.8, true, 10),
    section("regulatory", "FDA & HIPAA Compliance", 95, 1.5, true, 8),
    section("controls", "Clinical Validation", 90, 1.2, true, 8),
    section("governance", "Clinical Governance", 90, 1.0, true, 6),
  ],
};

export const DEEP_PRESET = {
  name: "ValidAIte Deep Enterprise",
  version: 1,
  passing_mode: "weighted",
  default_threshold: 90,
  sections: [
    section("identity", "Identity & Ownership", 90, 1.0, true, 8),
    section("purpose", "Purpose & Function", 90, 1.0, true, 10),
    section("users", "User Structure", 95, 1.5, true, 12),
    section("architecture", "System Architecture", 90, 1.2, true, 15),
    section("data", "Data", 90, 1.3, true, 14),
    section("decision", "Decision & Autonomy", 95, 1.5, true, 12),
    section("consequence", "Consequence & Impact", 95, 1.8, true, 12),
    section("regulatory", "Regulatory & Compliance", 90, 1.2, true, 10),
    section("operational", "Operational", 85, 1.0, true, 12),
    section("controls", "Controls & Assurance", 90, 1.2, true, 15),
    section("success", "Success & Performance", 85, 1.0, true, 10),
    section("governance", "Governance", 90, 1.0, true, 10),
    section("incidents", "Incidents & History", 85, 1.0, true, 8),
    section("third_party", "Third-Party & Supply Chain", 85, 0.9, false, 8),
    section("bias", "Bias & Fairness Deep-dive", 90, 1.3, true, 10),
    section("security", "Security Posture", 90, 1.2, true, 10),
    section("privacy", "Privacy Deep-dive", 90, 1.2, true, 10),
    section("testing", "Testing History", 85, 0.9, false, 8),
    section("change", "Change Management", 85, 0.8, false, 7),
    section("monitoring", "Monitoring & Alerting", 85, 0.9, false, 8),
  ],
};

export const PRESETS = {
  standard: { label: "Standard ValidAIte (12 sections, 92 items)", framework: STANDARD_PRESET },
  lite: { label: "Lightweight (6 sections, 32 items)", framework: LITE_PRESET },
  domain: { label: "Domain — Healthcare (8 sections, 63 items)", framework: DOMAIN_HEALTHCARE_PRESET },
  deep: { label: "Deep Enterprise (20 sections, 199 items)", framework: DEEP_PRESET },
};

/** Preset with full items[] hydrated from defaults or placeholders. */
export function getPresetFramework(key) {
  const preset = PRESETS[key]?.framework;
  if (!preset) return frameworkFromPreset(STANDARD_PRESET);
  return frameworkFromPreset(preset);
}

export { totalItems, requiredSectionsCount } from "./frameworkUtils";
